export default __webpack_public_path__ + "3b0a814220dcc4cfea17f6c0738cb043.svg";